/* Flooritize card media: measures the empty margin a product photo was shot with and frames every product to the same visual footprint. Presentation only. */
(function(){
  var cv=document.createElement('canvas'),N=56;cv.width=cv.height=N;var cx=cv.getContext('2d',{willReadFrequently:true});
  function frame(img){
    if(img.__fz||!img.naturalWidth)return;img.__fz=1;
    var box=img.parentNode,fit='object',s=1,tx=0,ty=0;
    try{
      cx.fillStyle='#fff';cx.fillRect(0,0,N,N);cx.drawImage(img,0,0,N,N);
      var d=cx.getImageData(0,0,N,N).data,px=function(x,y){var i=(y*N+x)*4;return[d[i],d[i+1],d[i+2]]},c=[px(1,1),px(N-2,1),px(1,N-2),px(N-2,N-2)],bg=[0,0,0],spread=0,k,x,y;
      for(k=0;k<3;k++){var mx=0,mn=255;c.forEach(function(q){bg[k]+=q[k]/4;mx=Math.max(mx,q[k]);mn=Math.min(mn,q[k])});spread=Math.max(spread,mx-mn)}
      if(spread>=14||bg[0]<226||bg[1]<226||bg[2]<226){fit='fill'}
      else{
        var x0=N,x1=-1,y0=N,y1=-1;
        for(y=0;y<N;y++)for(x=0;x<N;x++){var q=px(x,y);if(Math.abs(q[0]-bg[0])>8||Math.abs(q[1]-bg[1])>8||Math.abs(q[2]-bg[2])>8){if(x<x0)x0=x;if(x>x1)x1=x;if(y<y0)y0=y;if(y>y1)y1=y}}
        box.style.background='rgb('+Math.round(bg[0])+','+Math.round(bg[1])+','+Math.round(bg[2])+')';
        if(x1>=0&&((x1-x0+1)*(y1-y0+1))/(N*N)>=0.012){
          var W=box.clientWidth||1,H=box.clientHeight||1,ar=img.naturalWidth/img.naturalHeight,iw=ar>W/H?W:H*ar,ih=ar>W/H?W/ar:H;
          var cw=(x1-x0+1)/N*iw,ch=(y1-y0+1)/N*ih,T=0.8;
          s=Math.max(.6,Math.min(5,Math.min(T*W/cw,T*H/ch)));
          tx=-(((x0+x1+1)/2/N)-.5)*iw*s/W*100;ty=-(((y0+y1+1)/2/N)-.5)*ih*s/H*100;
          if(s>1.25)img.sizes=Math.ceil(W*s)+'px';
        }
      }
    }catch(e){fit='object'}
    img.style.setProperty('--s',s.toFixed(3));img.style.setProperty('--tx',tx.toFixed(2)+'%');img.style.setProperty('--ty',ty.toFixed(2)+'%');
    box.setAttribute('data-fit',fit);
  }
  document.addEventListener('load',function(e){var t=e.target;if(t&&t.classList&&t.classList.contains('fz-card__img'))frame(t)},true);
  function scan(){document.querySelectorAll('img.fz-card__img').forEach(function(i){if(i.complete)frame(i)})}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',scan);
})();
